import { render, staticRenderFns } from "./AccountTagTable.vue?vue&type=template&id=555a9f05&scoped=true&"
import script from "./AccountTagTable.vue?vue&type=script&lang=js&"
export * from "./AccountTagTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555a9f05",
  null
  
)

export default component.exports